export const tierPoints = {
	fantasy: 200000,
	delight: 75000,
	escape: 20000,
	play: 0,
};
const tokenTiers = [400000, 700000, 1000000];
const tokenStep = 500000;

const getTierInfo = (curPoints) => {
	const tiers = Object.entries(tierPoints).sort((a, b) => a[1] - b[1]);
	let currentTier = 'No tier';
	let nextTier = 'No tier';
	let pointsNeeded = 0;
	let percentComplete = 0;
	let tokensEarned = 0;
	let nextToken = 0;

	if (curPoints < tierPoints.fantasy) {
		//Still in tiers
		for (let i = 0; i < tiers.length; i++) {
			const [tier, points] = tiers[i];
			if (curPoints >= points) {
				currentTier = tier;
				if (i < tiers.length - 1) {
					nextTier = tiers[i + 1][0];
					pointsNeeded = tiers[i + 1][1] - curPoints;
					percentComplete = Math.round(((curPoints - points) * 100) / (tierPoints[nextTier] - points));
				}
			}
		}
	} else {
		//In tokens
		let base = tierPoints.fantasy;
		let diff = 0;
		//Check if the current points are in the range of the token tiers
		const range = tokenTiers.find((tier) => curPoints < tier);
		const lastTier = tokenTiers[tokenTiers.length - 1];
		if (range) {
			tokensEarned = tokenTiers.indexOf(range);
			nextToken = range;
			base = tokensEarned === 0 ? base : tokenTiers[tokensEarned - 1];
			//Else we're in token steps
		} else {
			const tokenBase = tokenTiers.length;
			base = lastTier;
			diff = Math.floor((curPoints - base) / tokenStep);
			base = diff > 0 ? diff * tokenStep + base : base;
			tokensEarned = diff + tokenBase;
			nextToken = base + tokenStep;
		}
		currentTier = 'fantasy';
		nextTier = 'token';
		pointsNeeded = nextToken - curPoints;
		percentComplete = Math.round(((curPoints - base) * 100) / (nextToken - base));
	}

	return { currentTier, nextTier, pointsNeeded, percentComplete, tokensEarned, nextToken };
};

export function mapCurrentUser(accountData, profileData, rewards, primeTokens) {
  const { percentComplete, tokensEarned, nextToken } = getTierInfo(profileData.basePoints);

  return {
    curPoints: profileData.basePoints,
    primetokens: primeTokens,
    wscore: rewards.patronAssets.wscore,
    curTier: profileData.clubState,
    nextTier: profileData.nextClubState,
    pointsNeeded: profileData.pointsNeeded,
    percentComplete: percentComplete,
    tokensEarned: tokensEarned,
    nextToken: nextToken,
  };
}

// Always assumes there will be 1 match.
export function getPreferredLocation(property) {
  const propertyMap = [
    {
      account: 'Aruba',
      prime: 'aruba',
    },
    {
      account: 'Atmore',
      prime: 'atmore',
    },
    {
      account: 'Bethlehem',
      prime: 'bethlehem',
    },
    {
      account: 'Chicago Southland',
      prime: 'chicagoSouthland',
    },
    {
      account: 'Curacao',
      prime: 'curacao',
    },
    {
      account: 'Montgomery',
      prime: 'montgomery',
    },
    {
      account: 'Miami',
      prime: 'miami',
    },
    {
      account: 'Wetumpka',
      prime: 'wetumpka',
    },
  ];

  const filtered = propertyMap.filter(p => p.account.includes(property));

  return filtered[0].prime;
}

